var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useState } from 'react';
import cookie from 'react-cookies';
import dayjs from 'dayjs';
import { AlertButtons } from '@r1-frontend/ui-react/components/Alert';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import BasePopup from '@r1-frontend/ui-react/components/popups/basePopup';
import { H3, H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';
import * as ST from './styled';
var CookieAlert = function (_a) {
    var _b = _a.cookieName, cookieName = _b === void 0 ? 'cookieAccepted' : _b, _c = _a.expirationTime, expirationTime = _c === void 0 ? 2592000 : _c, props = __rest(_a, ["cookieName", "expirationTime"]);
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = useState(false), isShownAlert = _e[0], setIsShownAlert = _e[1];
    var isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);
    var isAccepted = cookie.load(cookieName);
    useEffect(function () {
        setIsShownAlert(!isAccepted);
    }, []);
    var handleAccept = function () {
        var expirationDate = dayjs().add(expirationTime, 'seconds').toDate();
        cookie.save(cookieName, 'true', {
            path: '/',
            expires: expirationDate,
        });
        setIsShownAlert(false);
    };
    var popupText = <TextWrapper>
        <Paragraph4 $smaller $color={COLORS.TextHint}>
            Находясь на&nbsp;сайте АО&nbsp;«ЭР&nbsp;-&nbsp;Телеком Холдинг» dom.ru (далее&nbsp;- «сайт», «сайт dom.ru»)
            в&nbsp;сети «Интернет», вы&nbsp;соглашаетесь с&nbsp;настоящей политикой, в&nbsp;том числе с&nbsp;тем, что АО&nbsp;«ЭР&nbsp;-&nbsp;Телеком Холдинг»
            может использовать файлы cookie* и&nbsp;иные данные для&nbsp;их&nbsp;последующей обработки, в&nbsp;том числе,
            системами Google Analytics, Яндекс.Метрика, а&nbsp;также
            может передавать указанные данные третьим лицам для&nbsp;проведения исследований, выполнения работ, рекламной деятельности или&nbsp;оказания услуг.
        </Paragraph4>
        <Paragraph4 $smaller $color={COLORS.TextHint}>
            При посещении сайта dom.ru происходит автоматический сбор, в&nbsp;том числе, модели устройства, операционной системы, разрешения экрана,
            версия браузера, а&nbsp;также IP&nbsp;-&nbsp;адреса, информации о&nbsp;браузере и&nbsp;используемом в&nbsp;браузере языке, даты и&nbsp;времени
            доступа к&nbsp;сайту dom.ru, адресов просматриваемых страниц сайта dom.ru, истории поиска, иной информации о&nbsp;посещении сайта dom.ru.
        </Paragraph4>
        <H4 $smaller $withIndent={false}>
            Для&nbsp;чего могут использоваться cookie
        </H4>
        <Paragraph4 $smaller $color={COLORS.TextHint}>При&nbsp;посещении сайта dom.ru файлы cookie могут использоваться для:
            <li>обеспечения функционирования и&nbsp;безопасности сайта;</li>
            <li>улучшения качества сайта;</li>
            <li>регистрации в&nbsp;системе самообслуживания (личном кабинете);</li>
            <li>усовершенствования продуктов и&nbsp;(или)&nbsp;услуг и&nbsp;для&nbsp;разработки новых продуктов и&nbsp;(или)&nbsp;услуг;</li>
            <li>улучшения рекламных коммуникаций.</li>
        </Paragraph4>
        <H4 $smaller $withIndent={false}>Как управлять файлами cookie</H4>
        <Paragraph4 $smaller $color={COLORS.TextHint}>
            Используемые вами браузер и&nbsp;(или)&nbsp;устройство могут позволять вам блокировать, удалять или&nbsp;иным образом ограничивать использование файлов cookie.
            Чтобы узнать, как управлять файлами cookie с&nbsp;помощью используемых вами браузера или&nbsp;устройства, вы&nbsp;можете воспользоваться инструкцией,
            предоставляемой разработчиком браузера или&nbsp;производителем устройства.
        </Paragraph4>
        <Paragraph4 $smaller $color={COLORS.TextHint}>
            *Файлы cookie&nbsp;-&nbsp;это небольшие фрагменты текста, передаваемые в&nbsp;браузер с&nbsp;сайта, который вы&nbsp;открываете.
            С&nbsp;их&nbsp;помощью сайт запоминает информацию о&nbsp;ваших посещениях, которые хранятся до&nbsp;180&nbsp;дней. Это упрощает
            взаимодействие с&nbsp;сайтом и&nbsp;делает его полезнее для вас. В&nbsp;этих целях также используются другие технологии, включая
            уникальные идентификаторы (они нужны, чтобы различать браузеры, приложения или устройства), пиксели и&nbsp;локальное хранилище.
        </Paragraph4>
    </TextWrapper>;
    return (isShownAlert
        ? <ST.CookieAlert {...props}>
            <ST.StyledAlert type={'white'} withShadow>
                <Paragraph4>
                    Мы&nbsp;используем куки, чтобы вам было удобно.
                </Paragraph4>
                <AlertButtons>
                    <Button size={'small'} bType={'primary'} onClick={handleAccept}>Хорошо</Button>
                    <Button size={'small'} bType={'secondary'} onClick={function () { return setIsOpen(true); }}>Подробнее</Button>
                </AlertButtons>
            </ST.StyledAlert>
            <BasePopup isOpen={isOpen} title={<H3 $withIndent={false}>Политика обработки файлов cookie</H3>} onClose={function () { return setIsOpen(false); }} width={'600px'} height={'623px'} fullWidth={true} customBasePopupStyles={{
                topWrapper: {
                    h2: {
                        marginTop: '0 !important',
                        marginLeft: '0 !important',
                    },
                    paddingBottom: isMobile ? '16px !important' : '24px !important',
                },
                contentInner: {
                    marginTop: '0 !important',
                },
                contentWrapper: {
                    paddingRight: isMobile ? '4px !important' : '14px !important',
                },
            }} customDefaultPopupStyles={{
                popup: {
                    mobile: {
                        height: '663px !important',
                        padding: '24px 0 24px 24px !important',
                    },
                },
            }}>
                {popupText}
            </BasePopup>
        </ST.CookieAlert>
        : null);
};
export default CookieAlert;
